import React from 'react'
import { useState } from 'hooks'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { css, media, rgba, colors } from 'styles'
import Button from 'components/Button'
import Icon from 'components/Icon'
import { TranslationSwitch } from 'components/Translations'

const MobileMenu = ({ languages, current }) => {
  const [active, setActive] = useState(false)
  const expandedHeight = Math.ceil(languages?.length / 2) * 5 // items * 5 rems

  return (
    <StyledSwitch active={active} expandedHeight={expandedHeight}>
      <div className="buttons slot">
        <Button to="/myprofile/settings" label="sections/settings" />
        <Button className="toggle-button" onClick={() => setActive(!active)}>
          {current}
          <Icon name={`chevron-${active ? 'up' : 'down'}`} />
        </Button>
      </div>
      <TranslationSwitch />
    </StyledSwitch>
  )
}

export const StyledSwitch = styled.div`
  display: none;
  margin-top: 2rem;
  overflow: hidden;

  .buttons {
    display: flex;

    button,
    a {
      display: flex;
      flex: 1;
      font-size: 1.8rem;
      justify-content: center;
      align-items: center;
      padding: 1rem;
      text-transform: capitalize;
      border-color: ${colors.mainInverted};

      ~ button {
        margin-left: 5vw;
      }
    }

    .toggle-button {
      i {
        margin-left: 0.5rem;
      }
    }
  }

  .TranslationSwitch {
    display: flex;
    flex-flow: row wrap;
    margin-top: 2rem;
    max-height: 0;
    transition: max-height 0.5s ease-in-out;

    .translation {
      flex: 1 0 40%;
      max-width: calc(50% - 1rem);
      padding: 1.5rem 0;
      box-sizing: border-box;
      font-size: 1.8rem;
      font-weight: 300;
      color: ${colors.mainInverted};
      cursor: pointer;

      &:hover {
        background-color: ${rgba(colors.main, 0.1)};
      }
      &:nth-child(2n + 1) {
        margin-right: 5vw;
      }
    }

    .translation--active {
      font-weight: 700;
    }
  }

  ${p =>
    p.active &&
    css`
      .TranslationSwitch {
        max-height: ${p.expandedHeight}rem;
      }
    `}

  ${media.mobile`
    display: block;
  `}
`

const mapStateToProps = ({ siteConfig: { supportedLanguages }, account }) => ({
  current: supportedLanguages.find(e => e.id == account.main.lc)?.name,
  languages: supportedLanguages,
})

export default connect(mapStateToProps)(MobileMenu)
